import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPixverse = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.6483 7.82C15.0483 7.82 15.3733 8.145 15.3733 8.545V11.7675L18.9108 8.715C18.9634 8.66945 19.0279 8.63996 19.0967 8.63006C19.1655 8.62015 19.2358 8.63025 19.299 8.65915C19.3622 8.68805 19.4158 8.73453 19.4534 8.79304C19.491 8.85155 19.5109 8.91963 19.5108 8.98917V17.9325C19.5108 18.0011 19.4914 18.0682 19.4548 18.1262C19.4182 18.1842 19.3659 18.2307 19.3041 18.2603C19.2422 18.2898 19.1732 18.3012 19.1051 18.2932C19.037 18.2852 18.9725 18.2581 18.9192 18.215L15.3733 15.3475V18.59C15.3732 18.7627 15.3114 18.9296 15.1992 19.0608L15.1267 19.1342C15.0492 19.2022 14.9582 19.2529 14.8596 19.2829C14.761 19.3129 14.6572 19.3216 14.555 19.3083L5.46583 18.1333V19.22C5.46583 19.4121 5.38956 19.5964 5.25378 19.7324C5.118 19.8683 4.9338 19.9448 4.74167 19.945H0.725C0.532862 19.945 0.348582 19.8687 0.212642 19.7329C0.076702 19.5972 0.000220848 19.413 0 19.2208L0 8.54583C0 8.14583 0.325 7.82083 0.725 7.82H14.6483ZM9.51667 11.4433H5.815C5.719 11.4433 5.62693 11.4814 5.55897 11.5492C5.49101 11.617 5.45272 11.709 5.4525 11.805V14.1775C5.4525 14.3775 5.615 14.5392 5.815 14.5392H9.51667C9.71667 14.5392 9.87833 14.3775 9.87917 14.1775V11.805C9.87895 11.709 9.84066 11.617 9.7727 11.5492C9.70474 11.4814 9.61266 11.4433 9.51667 11.4433ZM10.6883 0C11.6506 0 12.5735 0.38227 13.254 1.06271C13.9344 1.74316 14.3167 2.66604 14.3167 3.62833C14.3167 4.59063 13.9344 5.51351 13.254 6.19395C12.5735 6.8744 11.6506 7.25667 10.6883 7.25667C9.72604 7.25667 8.80316 6.8744 8.12271 6.19395C7.44227 5.51351 7.06 4.59063 7.06 3.62833C7.06 2.66604 7.44227 1.74316 8.12271 1.06271C8.80316 0.38227 9.72604 0 10.6883 0ZM4.03833 1.09417C4.43536 1.09417 4.82851 1.17237 5.19531 1.3243C5.56212 1.47624 5.89541 1.69894 6.17615 1.97968C6.4569 2.26042 6.67959 2.59371 6.83153 2.96052C6.98347 3.32733 7.06167 3.72047 7.06167 4.1175C7.06167 4.51453 6.98347 4.90767 6.83153 5.27448C6.67959 5.64129 6.4569 5.97458 6.17615 6.25532C5.89541 6.53606 5.56212 6.75876 5.19531 6.9107C4.82851 7.06263 4.43536 7.14083 4.03833 7.14083C3.2365 7.14083 2.4675 6.8223 1.90051 6.25532C1.33353 5.68833 1.015 4.91934 1.015 4.1175C1.015 3.31566 1.33353 2.54667 1.90051 1.97968C2.4675 1.4127 3.2365 1.09417 4.03833 1.09417Z",
			fill: "url(#paint0_linear_17396_28140)"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_17396_28140",
			x1: 12.5,
			y1: .833333,
			x2: -.416666,
			y2: 20,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					stopColor: "#E8632A",
					stopOpacity: .996
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .586,
					stopColor: "#B465E6",
					stopOpacity: .996
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#979FD9",
					stopOpacity: .996
				})
			]
		}) })
	]
});
const ForwardRef = forwardRef(SvgPixverse);
export default ForwardRef;
